export default function Completer(){
  var resolve=function(value){}
  var promise=new Promise(_resolve=>{
    resolve=_resolve
  })
  return {
    promise,
    complete:(value)=>{
      resolve(value)
    }
  }
}